import { useContext, useMemo } from "react"
import { DoughnutChartsContext } from "../DoughnutChartsContext"

const useCharts = () => {
    const { fluencyDoughnut, percentAccuracyDoughnut, factoredPercentAccuracyDoughnut, fluencyReadingDoughnut, correctWordsPerMinuteDoughnut } = useContext(DoughnutChartsContext)

    const charts = useMemo(
        () => [
            {
                label: "קצב",
                chart: fluencyDoughnut
            },
            {
                label: "דיוק",
                chart: percentAccuracyDoughnut
            },
            {
                label: "דיוק משוקלל",
                chart: factoredPercentAccuracyDoughnut
            },
            {
                label: "שטף",
                chart: fluencyReadingDoughnut
            },
            {
                label: "מספר מילים נכונות לדקה",
                chart: correctWordsPerMinuteDoughnut
            }
        ], [fluencyDoughnut, percentAccuracyDoughnut, factoredPercentAccuracyDoughnut, fluencyReadingDoughnut, correctWordsPerMinuteDoughnut]
    )

    return charts
}

export default useCharts